import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-navy py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-204" data-mp="3fycqdmmec5as">
      <div className="mx-auto max-w-6xl px-4" data-id="element-205" data-mp="3b1cir79weuhk">
        <SectionHeading id="reviews-title" data-id="element-206" data-mp="3ayhypgusrboo">Testimonials from Educators</SectionHeading>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-207" data-mp="370aicn48wce0">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-electric/25 bg-panel p-6 shadow-lg shadow-black/30" data-id="element-208" data-mp="321zaghxigbyf" data-mpi={index}>
              <div className="flex text-gold" aria-label="5 out of 5 stars" data-id="element-209" data-mp="h5ooj7qca05u">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-210" data-mp="m2yf4qpgshv9" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-ink" data-id="element-211" data-mp="7a4yh1yghvp0">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-electric/15 pt-4" data-id="element-212" data-mp="c8okf2d1v7hd">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-electric/40 bg-navy text-sm font-extrabold text-electric" data-id="element-213" data-mp="zysbybcyrgs0">
                  {initials}
                </span>
                <span data-id="element-214" data-mp="v5g0l2xap6h7">
                  <b className="block text-sm text-white" data-id="element-215" data-mp="v4xyvqrv601w">{name}</b>
                  <small className="text-xs text-ink" data-id="element-216" data-mp="1ivadtllj0x1z">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}